import PropTypes from 'prop-types';

export const UserPropType = PropTypes.shape({
    // TODO: vervollständigen
    role: PropTypes.string.isRequired,
});
